import { z } from "zod";
import { NOTES_MAX, CONTACT_NAME_MAX, PHONE_MAX } from "@shared/constants/validation.js";

const BLOOD_TYPE_MAX = 16;

const nameField = z.string().trim().max(CONTACT_NAME_MAX).nullable().optional();
const phoneField = z.string().trim().max(PHONE_MAX).nullable().optional();
const longField = z.string().trim().max(NOTES_MAX).nullable().optional();

/**
 * Upsert schema for a child's medical history profile (1:1). All fields
 * optional; null clears a field; omitted fields stay `undefined` and the
 * service skips them (mirrors care preferences). Immunizations are a separate
 * list resource.
 */
export const upsertMedicalHistorySchema = z.object({
  primaryPhysicianName: nameField,
  primaryPhysicianPhone: phoneField,
  dentistName: nameField,
  dentistPhone: phoneField,
  bloodType: z.string().trim().max(BLOOD_TYPE_MAX).nullable().optional(),
  conditions: longField,
  pastIllnesses: longField,
  hospitalizations: longField,
  insuranceNotes: longField,
  notes: longField,
});

export type UpsertMedicalHistoryInput = z.infer<typeof upsertMedicalHistorySchema>;
